import React from "react"
import { useTranslation } from "react-i18next";

//MUI
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";

// Openlayers
import OlFeature from "ol/Feature"

// Custom
import InfoPaneActionButton from "./InfoPaneActionButton";

// Types
import { DCRecord } from "@/@types/lib/dataController";
import { PublicCommentsPaneProps } from "../SidebarPanes/PublicCommentsPane";

type InfoPaneCommentActionButtonProps = {
  objekt_type?: string;
  handleGoToComments: (newCommentPane: any) => void;
  data: {
    feature: OlFeature,
    record?: DCRecord,
  },
}

const InfoPaneCommentActionButton = (props: InfoPaneCommentActionButtonProps) => {

    const { objekt_type, handleGoToComments, data } = props;
  
    return(
        <InfoPaneActionButton
          title_ttoken={"buttons.comment"}
          icon={<ChatBubbleOutlineOutlinedIcon sx={{transform: "scale(0.8)"}} color="primary" fontSize="large" />}
          onClick={(evt) => handleGoToComments({ objekt_type, data })}
        />
    )

}

export default InfoPaneCommentActionButton;